module.exports = __webpack_public_path__ + "img/4.d971f96a.jpg";